// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__10qDG","header":"ReportDetails_header__3t4Ti","title":"ReportDetails_title__eTYVM","left":"ReportDetails_left__11P6_"};